const measurementJobTranslations = {
  SQUARE_FOOT: "Sq Ft",
  SQUARE_YARD: "Sq Yd",
  LINEAR_FOOT: "Ln Ft",
  UNIT: "Unit",
};

export default measurementJobTranslations;
